
const app = {
  clientId: process.env["REACT_APP_APP_CLIENT_ID"],

  apiOrigin: process.env["REACT_APP_APP_API_ORIGIN"],
  webOrigin: process.env["REACT_APP_APP_WEB_ORIGIN"],
}

export const Settings = {
  app,

  fetch: {
    credentials: (process.env["REACT_APP_FETCH_CREDENTIALS"] || "same-origin") as RequestCredentials
  },

  authorizeUri: `${app.apiOrigin}/api/authorize`,
  tokenUri: `${app.apiOrigin}/api/token`,

  grantType: "authorization_code",
  redirectUri: `${app.webOrigin}/oidc/callback`,
  scopes: [
    "openid",
    "profile",
    "links"
  ],

  privacyUri: "https://playeternity.io/EternityRPG_PrivacyPolicy.html",

  idps: [
    {
      id: "discord",
      name: "Discord",

      authorizationEndpoint: "https://discord.com/api/oauth2/authorize",

      authorizeRedirectUri: `${app.apiOrigin}/api/oidc/providers/discord/authorize`,
      startLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/discord/start-link`,
      finishLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/discord/finish-link`,

      clientId: "1046859915043537067",
      scopes: [
        "identify"
      ]
    },
    {
      id: "google",
      name: "Google",

      authorizationEndpoint: "https://accounts.google.com/o/oauth2/v2/auth",

      authorizeRedirectUri: `${app.apiOrigin}/api/oidc/providers/google/authorize`,
      startLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/google/start-link`,
      finishLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/google/finish-link`,

      clientId: "756301690405-bcu5kim43k56rjet855hm87pkah7e130.apps.googleusercontent.com",
      scopes: [
        "openid"
      ]
    },
    // {
    //   id: "apple",
    //   name: "Apple",

    //   authorizationEndpoint: "https://appleid.apple.com/auth/authorize",

    //   authorizeRedirectUri: `${app.apiOrigin}/api/oidc/providers/apple/authorize`,
    //   startLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/apple/start-link`,
    //   finishLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/apple/finish-link`,

    //   clientId: "io.playeternity.auth.web2",
    //   scopes: []
    // },
    // {
    //   id: "facebook",
    //   name: "Facebook",

    //   authorizationEndpoint: "https://www.facebook.com/v18.0/dialog/oauth",

    //   authorizeRedirectUri: `${app.apiOrigin}/api/oidc/providers/facebook/authorize`,
    //   startLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/facebook/start-link`,
    //   finishLinkRedirectUri: `${app.apiOrigin}/api/oidc/providers/facebook/finish-link`,

    //   clientId: "3527656737456002",
    //   scopes: [
    //   ]
    // }
  ]
}
